import { useContext } from 'react';
import { FabricCanvasContext } from '../contexts/fabricCanvasContextValue';

export const useFabricCanvas = () => {
  const ctx = useContext(FabricCanvasContext);
  if (!ctx) throw new Error('useFabricCanvas must be used inside FabricCanvasProvider');
  return ctx;
};
